import React from 'react';
import { ModalBase } from './ModalBase';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const AboutUsModal: React.FC<ModalProps> = ({ isOpen, onClose }) => {
  const imageUrl = "images/about-us-andorra.jpg";

  return (
    <ModalBase isOpen={isOpen} onClose={onClose} title="Quiénes Somos">
        <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-700 mb-3">Nuestra Misión</h3>
            <p className="text-slate-700 text-base leading-relaxed">
                Multas.EU, junto con nuestros servicios especializados Peritajes.EU y Juzgados.EU, forma una plataforma dedicada a ofrecer una defensa legal y técnica integral en toda Europa. Ayudamos a particulares y empresas a obtener informes periciales, recurrir sanciones administrativas y contar con representación en los tribunales. Nuestra misión es garantizar la equidad y la transparencia, proporcionando a los usuarios las herramientas y los recursos que necesitan para navegar por procesos legales complejos de manera eficaz.
            </p>
        </section>
        
        <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-700 mb-3">Nuestro Equipo</h3>
            <p className="text-slate-700 text-base leading-relaxed">
                Nuestro equipo está formado por peritos expertos, profesionales legales, tecnólogos y especialistas en atención al cliente apasionados por la defensa de los derechos de nuestros usuarios. Combinamos la experiencia técnica y legal con tecnología de vanguardia para ofrecer una experiencia fluida y eficiente.
            </p>
        </section>

        <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-700 mb-3">Nuestra Ubicación</h3>
            <p className="text-slate-700 text-base leading-relaxed mb-4">
                Nuestra oficina principal está ubicada en Andorra, una localización estratégica que nos permite gestionar eficientemente casos en toda Europa. Aunque operamos principalmente en línea, nuestra presencia física nos asegura poder coordinar eficazmente con profesionales y autoridades en todo el continente.
            </p>
            <div className="aspect-video overflow-hidden rounded-lg shadow-lg">
                <div 
                    className="h-full w-full bg-center bg-no-repeat bg-cover transition-transform duration-300 ease-in-out hover:scale-105" 
                    style={{ backgroundImage: `url("${imageUrl}")` }}
                    aria-label="Imagen de Andorra"
                ></div>
            </div>
        </section>

        <section className="mb-8">
            <h3 className="text-xl font-semibold text-gray-700 mb-3">Contáctanos</h3>
            <p className="text-slate-700 text-base leading-relaxed">
                Para consultas, soporte o comentarios, por favor, contáctanos en <a className="text-blue-600 hover:underline font-medium" href="mailto:informaci%C3%B3n@multas.eu">información@multas.eu</a>. Nos comprometemos a proporcionar una asistencia oportuna y útil a todos nuestros usuarios.
            </p>
        </section>
    </ModalBase>
  );
};